/**
 * @fileoverview Componente de reloj/cronómetro para tareas en proceso
 */

import React, { useState, useEffect } from 'react';
import { Badge } from 'reactstrap';

const TaskTimer = ({ startTime, className = '' }) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (!startTime) {
      setElapsedTime(0);
      return;
    }

    const start = new Date(startTime).getTime();
    
    const updateTimer = () => {
      const now = Date.now();
      const elapsed = Math.floor((now - start) / 1000); // elapsed time in seconds
      setElapsedTime(Math.max(0, elapsed));
    };

    // Update immediately
    updateTimer();

    // Update every second
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    } else {
      return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
  };

  const getTimerColor = () => {
    if (elapsedTime < 300) return 'success'; // Less than 5 minutes
    if (elapsedTime < 1800) return 'warning'; // Less than 30 minutes
    return 'danger'; // More than 30 minutes
  };

  if (!startTime) {
    return null;
  }

  return (
    <Badge 
      color={getTimerColor()} 
      className={`task-timer ${className}`}
      data-testid="task-timer"
    >
      <i className="fas fa-clock me-1"></i>
      {formatTime(elapsedTime)}
    </Badge>
  );
};

export default TaskTimer;
